module.exports = __webpack_public_path__ + "static/img/VU.fc5e6e09.svg";